<div class="h-full bg-body-background flex items-center justify-center p-6 overflow-y-auto">

  <div
       class="w-full max-w-2xl bg-component-inner border border-primary-border rounded-xl shadow-default p-8 md:p-10 my-auto">

    <div class="text-center mb-8">
      <div
           class="w-16 h-16 bg-alt-background rounded-2xl flex items-center justify-center mx-auto mb-4 border border-secondary-border shadow-sm">
        <i class="fas fa-layer-plus text-2xl text-primary"></i>
      </div>
      <h2 class="text-heading text-2xl md:text-3xl font-bold tracking-tight" [style.color]="'var(--primary-text-color)'">{{
        config.texts.createTitle }}</h2>
      <p class="text-sm md:text-base text-secondary-text mt-2">{{ config.texts.createSubtitle }}</p>
    </div>

    <form (ngSubmit)="createWorkspace()"
          class="flex flex-col gap-6">

      <div class="flex flex-col gap-6 w-full">
        <div class="flex flex-col gap-2 w-full">
             <label for="workspaceName"
               class="text-sm font-semibold text-primary-text"
               [style.color]="'var(--primary-text-color)'">
            {{ config.texts.nameLabel }} <span class="text-error">*</span>
          </label>
             <input id="workspaceName"
               type="text"
               name="workspaceName"
               [ngModel]="workspaceName()"
               (ngModelChange)="onNameChange($event)"
               [placeholder]="config.texts.namePlaceholder"
               required
               [style.backgroundColor]="'var(--input-background-color)'"
               [style.color]="'var(--primary-text-color)'"
               [style.borderColor]="'var(--secondary-border-color)'"
               class="w-full border rounded-lg px-4 py-3 placeholder:text-placeholder focus:outline-none focus:border-primary focus:ring-1 focus:ring-primary transition-colors" />
        </div>

        <div class="flex flex-col gap-2 w-full">
             <label for="workspaceKey"
               class="text-sm font-semibold text-primary-text"
               [style.color]="'var(--primary-text-color)'">
            {{ config.texts.keyLabel }} <span class="text-error">*</span>
          </label>
             <input id="workspaceKey"
               type="text"
               name="workspaceKey"
               [ngModel]="workspaceKey()"
               (ngModelChange)="onKeyChange($event)"
               [placeholder]="config.texts.keyPlaceholder"
               required
               [style.backgroundColor]="'var(--input-background-color)'"
               [style.color]="'var(--primary-text-color)'"
               [style.borderColor]="'var(--secondary-border-color)'"
               class="w-full border rounded-lg px-4 py-3 placeholder:text-placeholder focus:outline-none focus:border-primary focus:ring-1 focus:ring-primary transition-colors font-mono text-sm" />
        </div>
      </div>

      <div class="flex flex-col gap-2 w-full">
         <label for="workspaceDescription"
           class="text-sm font-semibold text-primary-text"
           [style.color]="'var(--primary-text-color)'">
          {{ config.texts.descriptionLabel }}
        </label>
        <textarea id="workspaceDescription"
            name="workspaceDescription"
            [(ngModel)]="workspaceDescription"
            [placeholder]="config.texts.descriptionPlaceholder"
            rows="3"
            [style.backgroundColor]="'var(--input-background-color)'"
            [style.color]="'var(--primary-text-color)'"
            [style.borderColor]="'var(--secondary-border-color)'"
            class="w-full border rounded-lg px-4 py-3 placeholder:text-placeholder focus:outline-none focus:border-primary focus:ring-1 focus:ring-primary transition-colors resize-y custom-scrollbar"></textarea>
      </div>

      <div class="pt-4 border-t border-primary-border mt-2">
        <button type="submit"
                [disabled]="isSubmitting() || !workspaceName().trim() || !workspaceKey().trim()"
                class="w-full md:w-auto md:float-right bg-primary hover:bg-hover-primary text-primary-button-text font-semibold rounded-lg px-8 py-3 focus:outline-none focus:ring-2 focus:ring-focus-ring focus:ring-offset-2 focus:ring-offset-component-inner transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2 shadow-sm">
          @if (isSubmitting()) {
          <i class="fas fa-circle-notch fa-spin"></i>
          }
          <span>{{ config.texts.createButton }}</span>
        </button>
      </div>

    </form>

  </div>
</div>
<div>
  <!-- <rapider-list-grid></rapider-list-grid> -->
</div>